import { authorizationHeader } from '@picsart/growth-rc/services/auth';

import getAccessToken from '@/utils/user/getAccessToken';

/**
 * Headers for authenticated JSON requests — Bearer token + Content-Type.
 * Single source for the auth+JSON pair so endpoints can't drift apart.
 */
const getAuthJsonHeaders = (): HeadersInit => ({
  'Content-Type': 'application/json',
  ...authorizationHeader(getAccessToken()),
});

export default getAuthJsonHeaders;
